var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-pagination" }, [
    _c(
      "div",
      {
        staticClass:
          "g-row g-row--align_center g-row--justify_center g-row--space_5xl g-row--space_8xl-md"
      },
      [
        _vm.hasPrev()
          ? _c("div", { staticClass: "g-cell g-cols g-cols--narrow-xs" }, [
              _c(
                "div",
                {
                  staticClass: "pagination-item pagination-item--arrow left",
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.prevPage)
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "39",
                        height: "39",
                        viewBox: "0 0 39 39",
                        fill: "none"
                      }
                    },
                    [
                      _c("g", { attrs: { opacity: "0.3" } }, [
                        _c("path", {
                          attrs: {
                            d: "M30.875 19.5L8.125 19.5",
                            stroke: "white",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }
                        }),
                        _c("path", {
                          attrs: {
                            d: "M19.5 30.875L8.125 19.5L19.5 8.125",
                            stroke: "white",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }
                        })
                      ])
                    ]
                  )
                ]
              )
            ])
          : _vm._e(),
        _c("div", { staticClass: "g-cell g-cols g-cols--narrow-xs" }, [
          _c(
            "div",
            { staticClass: "g-row g-row--align_center g-row--justify_center" },
            [
              _c("div", { staticClass: "g-cell g-cols g-cols--narrow-xs" }, [
                _c(
                  "div",
                  { staticClass: "g-row g-row--align_center g-row--space_5xl" },
                  _vm._l(_vm.pages, function(page) {
                    return _c(
                      "div",
                      {
                        key: page,
                        staticClass: "g-cell g-cols g-cols--narrow-xs"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pagination-item",
                            class: { "is-active": _vm.currentPage === page },
                            on: {
                              click: function($event) {
                                return _vm.changePage(page)
                              }
                            }
                          },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "ds-caption ds-caption--c_white ds-caption--size_md ds-caption--w_l ds-caption--op-4"
                              },
                              [_vm._v(_vm._s(page))]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ]
          )
        ]),
        _vm.hasNext()
          ? _c("div", { staticClass: "g-cell g-cols g-cols--narrow-xs" }, [
              _c(
                "div",
                {
                  staticClass: "pagination-item pagination-item--arrow right",
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.nextPage)
                    }
                  }
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "39",
                        height: "39",
                        viewBox: "0 0 39 39",
                        fill: "none"
                      }
                    },
                    [
                      _c("g", { attrs: { opacity: "0.3" } }, [
                        _c("path", {
                          attrs: {
                            d: "M8.125 19.5L30.875 19.5",
                            stroke: "white",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }
                        }),
                        _c("path", {
                          attrs: {
                            d: "M19.5 30.875L30.875 19.5L19.5 8.125",
                            stroke: "white",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }
                        })
                      ])
                    ]
                  )
                ]
              )
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0db53577", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0db53577","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/UiElements/UiLimitPagination.vue
// module id = 124
// module chunks = 0